import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
  MatSnackBarHorizontalPosition,
  MatSnackBarConfig,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  ref: MatSnackBarRef<any> | null = null;
  constructor(private readonly snackBar: MatSnackBar) {}

  static defaultOptions: MatSnackBarConfig = {
    horizontalPosition: 'right' as MatSnackBarHorizontalPosition,
    verticalPosition: 'top' as MatSnackBarVerticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar'],
  };

  /**
   * Presents a toast displaying the message with a green background
   * @param message Message to display
   * @example
   * this.notificationService.success("confirm oked");
   */
  success(message: string) {
    this.openSnackBar(message, '');
  }

  dismiss() {
    this.ref?.dismiss();
  }

  /**
   * Presents a toast displaying the message with a red background
   * @param message Message to display
   * @example
   * this.notificationService.error("confirm canceled");
   */
  error(message: string) {
    this.openSnackBar(message, '', { panelClass: ['error-snackbar'] });
  }

  /**
   * Displays a toast with provided message
   * @param message Message to display
   * @param action Action text, e.g. Close, Done, etc
   * @param className Optional extra css class to apply
   * @param duration Optional number of SECONDS to display the notification for
   */
  openSnackBar(message: string, action: string, options: MatSnackBarConfig = {}) {
    this.ref = this.snackBar.open(message, action, {
      ...NotificationService.defaultOptions,
      ...options,
    });
  }
}
